import { render, staticRenderFns } from "./import1.vue?vue&type=template&id=9db0b086&scoped=true&"
import script from "./import1.vue?vue&type=script&lang=js&"
export * from "./import1.vue?vue&type=script&lang=js&"
import style0 from "./import1.vue?vue&type=style&index=0&id=9db0b086&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9db0b086",
  null
  
)

export default component.exports